import { render, staticRenderFns } from "./Docs.vue?vue&type=template&id=6e3c7896&scoped=true"
import script from "./Docs.vue?vue&type=script&lang=js"
export * from "./Docs.vue?vue&type=script&lang=js"
import style0 from "./Docs.vue?vue&type=style&index=0&id=6e3c7896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3c7896",
  null
  
)

export default component.exports